import {createAction} from 'redux-act';

export const SET_ACTIVE_ORDERS = createAction('ordersV2/SET_ACTIVE_ORDERS');
export const SET_ACTIVE_EVENT_ORDERS = createAction(
  'ordersV2/SET_ACTIVE_EVENT_ORDERS'
);
export const CLEAR_ACTIVE_ORDERS = createAction('ordersV2/CLEAR_ACTIVE_ORDERS');
export const SET_NEW_ORDERS = createAction('ordersV2/SET_NEW_ORDERS');
export const SET_ORDERS_SORTING = createAction('ordersV2/SET_ORDERS_SORTING');
export const SET_ORDERS_SEARCH = createAction('ordersV2/SET_ORDERS_SEARCH');
export const CLEAR_NEW_ORDERS = createAction('ordersV2/CLEAR_NEW_ORDERS');
export const RUN_GET_ACTIVE_ORDERS_JOB = createAction(
  'ordersV2/RUN_GET_ACTIVE_ORDERS_JOB'
);
export const STOP_GET_ACTIVE_ORDERS_JOB = createAction(
  'ordersV2/STOP_GET_ACTIVE_ORDERS_JOB'
);
export const CHANGE_REFUNDS_ACTIVE = createAction(
  'ordersV2/CHANGE_REFUNDS_ACTIVE'
);
export const CHANGE_STATUS_ACTIVE = createAction(
  'ordersV2/CHANGE_STATUS_ACTIVE'
);
export const CHANGE_STATUS_ACTIVE_SUCCESS = createAction(
  'ordersV2/CHANGE_STATUS_ACTIVE_SUCCESS'
);
export const CHANGE_CURRENT_LOCATION_TIMEZONE = createAction(
  'ordersV2/CHANGE_CURRENT_LOCATION_TIMEZONE'
);
export const APPEND_LARGE_ORDERS = createAction('ordersV2/APPEND_LARGE_ORDERS');
export const PREPEND_LARGE_ORDER = createAction('ordersV2/PREPEND_LARGE_ORDER');
export const SET_LARGE_ORDER_INFO = createAction(
  'ordersV2/SET_LARGE_ORDER_INFO'
);
export const REMOVE_LARGE_ORDER = createAction('ordersV2/REMOVE_LARGE_ORDER');
export const CLEAR_LARGE_ORDERS = createAction('ordersV2/CLEAR_LARGE_ORDERS');
export const FETCH_LARGE_ORDER_INFO = createAction(
  'ordersV2/FETCH_LARGE_ORDER_INFO'
);
export const CREATE_LARGE_ORDER_DRIVERS = createAction(
  'ordersV2/CREATE_LARGE_ORDER_DRIVERS'
);
export const SET_LARGE_ORDER_SUBMITTING = createAction(
  'ordersV2/SET_LARGE_ORDER_SUBMITTING'
);
export const HOLD_NEW_ORDERS = createAction('ordersV2/HOLD_NEW_ORDERS');
export const APPEND_PENDING_NEW_ORDERS = createAction(
  'ordersV2/APPEND_PENDING_NEW_ORDERS'
);
